import { createContext } from "react";

const JsonDataContext = createContext({});

export default JsonDataContext;
